import type { ReactNode } from 'react';
import { cn } from 'lib/utils';

// Cap the content width instead of using viewport-based padding: the sidebar takes ~280px,
// so large 2xl padding left too little room for the 3-column card grid at 1536px.
export const CONFIGURATION_LAYOUT_CLASSNAME =
  'mx-auto flex w-full min-w-0 max-w-[1124px] flex-col gap-10 py-1 px-8 sm:py-4';

function ConfigurationLayout({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={cn(CONFIGURATION_LAYOUT_CLASSNAME, className)}>{children}</div>;
}

export default ConfigurationLayout;
